// Dependencies
import { FC, MouseEventHandler, ReactElement } from "react";

// Styles
import { StyledIconButton } from "./IconButton.styled";

interface IconButtonProps {
  children: ReactElement;
  onClick: MouseEventHandler;
}

const IconButton: FC<IconButtonProps> = ({ children, onClick }) => {
  return <StyledIconButton onClick={onClick}>{children}</StyledIconButton>;
};

export default IconButton;
